import { render } from "./SuggestedListingPropertyWrapper.vue?vue&type=template&id=1557f0e5"
import script from "./SuggestedListingPropertyWrapper.vue?vue&type=script&lang=js"
export * from "./SuggestedListingPropertyWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__